/**
 * @generated SignedSource<<73fd22d3f4f4c96b334ca9367abf83d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AirportSelect_data$data = {
  readonly airports: ReadonlyArray<{
    readonly code: string;
    readonly id: string;
    readonly name: string;
  }>;
  readonly " $fragmentType": "AirportSelect_data";
};
export type AirportSelect_data$key = {
  readonly " $data"?: AirportSelect_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"AirportSelect_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "search"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": require('./AirportsRefetchQuery.graphql')
    }
  },
  "name": "AirportSelect_data",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 10
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        }
      ],
      "concreteType": "Airport",
      "kind": "LinkedField",
      "name": "airports",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "d78d44d5a841215ffb074b8e074109fd";

export default node;
